<div class="book-appointment-search">
  <h2>Add Insurance</h2>
  <form class="form" [formGroup]="form" autocomplete="off" (ngSubmit)="onSearch()">
    <div class="form__group">
      <input type="text" formControlName="crmPolicyHolderName" class="form__control" pInputText placeholder="Insurance Name" style="width: 100%" />
      <span class="error-msg" *ngIf="form.get('crmPolicyHolderName')?.invalid && form.get('crmPolicyHolderName')?.touched"> Insurance name is required </span>
    </div>
    <div class="form__actions">
      <button type="submit" class="btn btn--primary">Add</button>
    </div>
  </form>
</div>
